<template>
  <el-row>
    <el-col :span="24">
      <el-button type="primary" @click="newTemplate">New Template</el-button>
      <el-button type="primary" @click="settingTemplate">关联设定</el-button>
    </el-col>
  </el-row>
  <div>
    <el-table :data="list" border style="width: 1200px">
      <el-table-column label="模板编号" prop="id" width="300" />
      <el-table-column label="模板名称" prop="template_name" width="500" />
      <el-table-column label="关联设定" prop="template_setting" width="200">
        <template #default="{ row }">
          <div
            v-for="(item, index) in JSON.parse(row.template_setting)"
            :key="'setting)' + index"
          >
            <el-button link type="primary" @click="OpenSetting(item.id)">{{
              item.name
            }}</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="" width="200">
        <template #default="{ row }">
          <el-button type="primary" @click="edit(row.id)">Edit</el-button>
          <el-button type="danger" @click="del(row.id)">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { request } from '@/network/request';
import { ElMessageBox } from 'element-plus';
import { id } from 'element-plus/es/locale';

const list = ref([]);
onMounted(async () => {
  var res = await request({
    url: '/admin/GetTAndCTemplateList',
    method: 'post',
    data: {
      pageIndex: 1,
      pageSize: 15,
    },
  }).then((res) => res.data);

  list.value = res.data;
});

const del = async (id) => {
  ElMessageBox.confirm(
    'Are you sure to delete this template?',
    'Delete Template',
    {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      customClass: 'matrix-message-box',
      confirmButtonClass: 'right-confirm-1',
    }
  )
    .then(() => {
      Delete(id);
    })
    .catch(() => {
      console.log('cancel');
    });
};

const Delete = (id) => {
  request({
    url: '/admin/DeleteTAndCTemplate',
    method: 'post',
    params: { id },
  }).then(() => {
    list.value.splice(
      list.value.findIndex((item) => item.id === id),
      1
    );
  });
};

const newTemplate = () => {
  edit('');
};

const edit = (id) => {
  window.location.href = `/tandcTemplate?type=edit&id=${id}`;
};

const settingTemplate = () => {
  window.location.href = '/tandcSetting';
};

const OpenSetting = (id) => {
  window.location.href = `/tandcSetting?id=${id}`;
};
</script>
<style scoped></style>
